module.exports = __webpack_public_path__ + "img/icon-sweet.2fee4a33.svg";